var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NodeViewWrapper',{staticClass:"vue-component",attrs:{"as":"p"}},[_c('NodeViewContent',{staticClass:"paragraph-content"}),_vm._v(" "),(_vm.isLoggedIn && _vm.text)?_c('NcReferenceList',{attrs:{"text":_vm.text,"limit":1,"contenteditable":"false"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }